import React from 'react';


class ModalPlaceOrderNotValid extends React.Component {

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });
    }


    backResultPage = () => {
        this.props.setModalPlaceOrderNotValidClosed();
    }


    setModalOrderConfirmationClosed = () =>  {
        this.props.setModalPlaceOrderNotValidClosed();
    }
    

  render() {


    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg2" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderConfirmationClosed}></div>

                            <div className="modal_order_inner_bg">
                              
                                    <div className="modal_order_top">                            
                                        <div className="modal_order_title1">ההקצאה אינה זמינה</div>
                                    </div>


                                    <div className="modal_order_title_hotel directionRtl">
                                    
                                    </div>

                                  
                                        <div className="cntered-flex order_cancel_text directionRtl">
                                            קיימת בעיה בהקצאה זאת,
                                            <br />
                                            או ההקצאה אינה זמינה יותר.
                                        </div>  
                                    




                                <div className="modal_order_confirmation_container">
                                
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button"
                                                onClick={() => this.backResultPage()}>
                                            <span className="hp_search_main_button_title">
                                            חזרה לדף תוצאות
                                            </span>
                                        </div>
                                    </div>
                                            
                                </div>

                            </div>

                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}



export default ModalPlaceOrderNotValid;